import React from 'react';
import { ReactComponent } from 'Common/components/Icons/signature.svg';

const Signature = () => <ReactComponent className="MuiSvgIcon-root" />;

export default Signature;
